import { render, staticRenderFns } from "./EmployeeFormSubmissionDetail.vue?vue&type=template&id=2c85b849&"
import script from "./EmployeeFormSubmissionDetail.vue?vue&type=script&lang=ts&"
export * from "./EmployeeFormSubmissionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeFormSubmissionDetail.vue?vue&type=style&index=0&id=2c85b849&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports